import { render, staticRenderFns } from "./StakeholderListRow.vue?vue&type=template&id=f02a388a&"
import script from "./StakeholderListRow.vue?vue&type=script&lang=ts&"
export * from "./StakeholderListRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports